/**
 * ContentFooterActionSlot - Renders trailing actions in the content footer.
 *
 * This slot appears beside the content footer controls and is intended for compact
 * actions that should stay aligned to the footer's bottom-right edge.
 */

import React from 'react';

import {
  type MediaBrowserPanelProps,
  type MediaConfigWithDefaults,
} from '../../Component';
import {type StepMeta} from '../../types';
import {ControlRenderer} from '../renderers/ControlRenderer';
import {type GridData, type SlotRegistry} from '../types';

export type ContentFooterActionSlotProps = {
  controls: NonNullable<SlotRegistry[keyof SlotRegistry]>;
  config: MediaConfigWithDefaults;
  updateConfig: MediaBrowserPanelProps['updateConfig'];
  stepMeta: StepMeta;
  isMaxStepLoading: boolean;
  mediaBrowserSize: {width: number; height: number};
  gridData: GridData;
  isFullScreenPanelPage?: boolean;
};

export const ContentFooterActionSlot: React.FC<
  ContentFooterActionSlotProps
> = ({
  controls,
  config,
  updateConfig,
  stepMeta,
  isMaxStepLoading,
  mediaBrowserSize,
  gridData,
  isFullScreenPanelPage,
}) => {
  if (controls.length === 0) {
    return null;
  }

  return (
    <div className="hidden shrink-0 self-stretch flex-col items-end justify-end pt-8 [@container(min-width:350px)]:flex">
      {controls.map((control, idx) => (
        <ControlRenderer
          key={`content-footer-action-${control.control}`}
          control={control}
          index={idx}
          config={config}
          updateConfig={updateConfig}
          stepMeta={stepMeta}
          isMaxStepLoading={isMaxStepLoading}
          mediaBrowserSize={mediaBrowserSize}
          gridData={gridData}
          isFullScreenPanelPage={isFullScreenPanelPage}
        />
      ))}
    </div>
  );
};
